export default "__VITE_ASSET__B$hE6cWh__"